import { useEffect, useRef, useState } from 'react';
export const useGetCookie = cookieName => {
  const isMounted = useRef(false);
  const [cookie, setCookie] = useState('');
  useEffect(() => {
    isMounted.current = true;
    const getCookie = () => document.cookie.split('; ').reduce((total, currentCookie) => {
      const item = currentCookie.split('=');
      const key = item[0];
      const value = item[1];
      return cookieName === key ? decodeURIComponent(value) : total;
    }, '');
    if (isMounted.current) setCookie(getCookie());
    return () => {
      isMounted.current = false;
    };
  }, [cookieName]);
  return cookie;
};